import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Button, CartFooter, CartHeader } from "@components/atoms";
import { TaxedMoney } from "@components/containers";
import { CartRow } from "@components/organisms";
import { Cart, CartEmpty } from "@components/templates";
import { useCart, useCheckout, useUserDetails } from "@sdk/react";
import { BASE_URL } from "@temp/core/config";
import React from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";

// const title = <h1 data-cy="cartPageTitle">My Cart</h1>;
var getShoppingButton = function getShoppingButton(history, intl) {
  return React.createElement(Button, {
    "data-cy": "cartPageBtnContinueShopping",
    onClick: function onClick() {
      return history.push(BASE_URL);
    }
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "CONTINUE SHOPPING",
    "id": "@next.pages.CartPage.CartPage.36913639"
  }, "id", "@next.pages.CartPage.CartPage.36913639")));
};

var getCheckoutButton = function getCheckoutButton(history, user, intl) {
  return React.createElement(Button, {
    "data-cy": "cartPageBtnProceedToCheckout",
    onClick: function onClick() {
      return history.push(user ? "/checkout/" : "/login/");
    }
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "PROCEED TO CHECKOUT",
    "id": "@next.pages.CartPage.CartPage.1304869656"
  }, "id", "@next.pages.CartPage.CartPage.1304869656")));
};

var cartHeader = React.createElement(CartHeader, null);

var prepareCartFooter = function prepareCartFooter(totalPrice, shippingTaxedPrice, promoTaxedPrice, subtotalPrice) {
  return React.createElement(CartFooter, {
    subtotalPrice: React.createElement(TaxedMoney, {
      "data-cy": "cartPageSubtotalPrice",
      taxedMoney: subtotalPrice
    }),
    totalPrice: React.createElement(TaxedMoney, {
      "data-cy": "cartPageTotalPrice",
      taxedMoney: totalPrice
    }),
    shippingPrice: shippingTaxedPrice && shippingTaxedPrice.gross.amount !== 0 && React.createElement(TaxedMoney, {
      "data-cy": "cartPageShippingPrice",
      taxedMoney: shippingTaxedPrice
    }),
    discountPrice: promoTaxedPrice && promoTaxedPrice.gross.amount !== 0 && React.createElement(TaxedMoney, {
      "data-cy": "cartPageShippingPrice",
      taxedMoney: promoTaxedPrice
    })
  });
};

var generateCart = function generateCart(items, removeItem, updateItem) {
  return items === null || items === void 0 ? void 0 : items.map(function (_ref, index) {
    var _variant$product, _variant$product2, _variant$product3, _variant$product3$thu, _variant$pricing, _variant$attributes;

    var id = _ref.id,
        variant = _ref.variant,
        quantity = _ref.quantity,
        totalPrice = _ref.totalPrice,
        productAttributes = _ref.productAttributes;
    return React.createElement(CartRow, {
      key: id ? "id-".concat(id) : "idx-".concat(index),
      index: index,
      name: (variant === null || variant === void 0 ? void 0 : (_variant$product = variant.product) === null || _variant$product === void 0 ? void 0 : _variant$product.name) || "",
      maxQuantity: variant.quantityAvailable || quantity,
      quantity: quantity,
      onRemove: function onRemove() {
        return removeItem(variant.id, productAttributes || []);
      },
      onQuantityChange: function onQuantityChange(newQuantity) {
        return updateItem(variant.id, newQuantity, productAttributes || []);
      },
      thumbnail: _objectSpread({}, variant === null || variant === void 0 ? void 0 : (_variant$product2 = variant.product) === null || _variant$product2 === void 0 ? void 0 : _variant$product2.thumbnail, {
        alt: (variant === null || variant === void 0 ? void 0 : (_variant$product3 = variant.product) === null || _variant$product3 === void 0 ? void 0 : (_variant$product3$thu = _variant$product3.thumbnail) === null || _variant$product3$thu === void 0 ? void 0 : _variant$product3$thu.alt) || ""
      }),
      totalPrice: React.createElement(TaxedMoney, {
        "data-cy": "cartPageItem".concat(index, "TotalPrice"),
        taxedMoney: totalPrice
      }),
      unitPrice: React.createElement(TaxedMoney, {
        "data-cy": "cartPageItem".concat(index, "UnitPrice"),
        taxedMoney: variant === null || variant === void 0 ? void 0 : (_variant$pricing = variant.pricing) === null || _variant$pricing === void 0 ? void 0 : _variant$pricing.price
      }),
      sku: variant.sku,
      attributes: (_variant$attributes = variant.attributes) === null || _variant$attributes === void 0 ? void 0 : _variant$attributes.map(function (attribute) {
        return {
          attribute: {
            id: attribute.attribute.id,
            name: attribute.attribute.name || ""
          },
          values: attribute.values.map(function (value) {
            return {
              id: value === null || value === void 0 ? void 0 : value.id,
              name: (value === null || value === void 0 ? void 0 : value.name) || "",
              value: value === null || value === void 0 ? void 0 : value.value
            };
          })
        };
      })
    });
  });
};

export var CartPage = function CartPage(props) {
  var _checkout$shippingMet;

  var intl = useIntl();
  var history = useHistory();

  var _useUserDetails = useUserDetails(),
      user = _useUserDetails.data;

  var _useCheckout = useCheckout(),
      checkout = _useCheckout.checkout;

  var _useCart = useCart(),
      loaded = _useCart.loaded,
      removeItem = _useCart.removeItem,
      updateItem = _useCart.updateItem,
      items = _useCart.items,
      totalPrice = _useCart.totalPrice,
      subtotalPrice = _useCart.subtotalPrice,
      shippingPrice = _useCart.shippingPrice,
      discount = _useCart.discount;

  var shippingTaxedPrice = (checkout === null || checkout === void 0 ? void 0 : (_checkout$shippingMet = checkout.shippingMethod) === null || _checkout$shippingMet === void 0 ? void 0 : _checkout$shippingMet.id) && shippingPrice ? {
    gross: shippingPrice,
    net: shippingPrice
  } : null;
  var promoTaxedPrice = discount && {
    gross: discount,
    net: discount
  };

  if (loaded && (items === null || items === void 0 ? void 0 : items.length)) {
    return React.createElement(Cart, {
      title: React.createElement("h1", {
        "data-cy": "cartPageTitle"
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "My Cart",
        "id": "@next.pages.CartPage.CartPage.3173718889"
      }, "id", "@next.pages.CartPage.CartPage.3173718889"))),
      button: getCheckoutButton(history, user, intl),
      cartHeader: cartHeader,
      cartFooter: prepareCartFooter(totalPrice, shippingTaxedPrice, promoTaxedPrice, subtotalPrice),
      cart: items && generateCart(items, removeItem, updateItem)
    });
  }

  return React.createElement(CartEmpty, {
    button: getShoppingButton(history, intl)
  });
};